import { HeaderWrapper } from 'layouts';
import type { Media, VideoContentObject } from 'models';
import { useState } from 'react';
import { HeaderContent } from 'ui';
import { useGetVideoStatusTagProperties } from '../../../hooks';
import { VideoEditModal } from '../../components';
import { VideoHeaderAsset } from '../video-header-asset';
import { useActions } from './hooks';

type P = {
  onVideoDeleted: () => Promise<void>;
  trailerData?: Media;
  videoContentObject: VideoContentObject;
};

const VideoDetailDraftHeader = ({ onVideoDeleted, trailerData, videoContentObject }: P) => {
  const [isEditVideoModalOpened, setIsEditVideoModalOpened] = useState(false);
  const { actions, contextHolder } = useActions({
    onRequestEdit: setIsEditVideoModalOpened,
    onVideoDeleted,
    videoContentObject,
  });

  const getStatusTagProperties = useGetVideoStatusTagProperties();

  return (
    <>
      {contextHolder}
      <HeaderWrapper
        left={<VideoHeaderAsset trailerData={trailerData} videoContentObject={videoContentObject} />}
        right={
          <HeaderContent
            actions={actions}
            tags={getStatusTagProperties({ status: videoContentObject.video.status })}
            timeInfo={{ date: videoContentObject.video.recordedAt }}
            title={videoContentObject.video.name}
          />
        }
      />

      <VideoEditModal
        isOpened={isEditVideoModalOpened}
        onClose={() => {
          setIsEditVideoModalOpened(false);
        }}
        videoContentObject={videoContentObject}
      />
    </>
  );
};

export default VideoDetailDraftHeader;
